
<span v-html="text"></span>
